<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <div>
      <v-switch
        v-model="gradient"
        class="py-0"
        :label="$t('gradient_colors')"
      />

      <!-- حالت گرادینت -->
      <v-row v-if="gradient" class="mx-auto" flat>
        <v-col class="pa-2" cols="12" md="6">
          <v-card flat max-width="200">
            <div class="rowinfo">
              <v-autocomplete
                v-model="colors.dir"
                :items="direction"
                dense
                hide-details
                item-text="text"
                item-value="value"
                :label="$t('color_direction')"
                outlined
                class="contentinfo"
              />
              <help-info
                :element-name="`${serviceName}-${componentName}-colors-dir`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                :label="$t('color_direction')"
              />
            </div>
          </v-card>
        </v-col>

        <v-col class="pa-2 d-none d-md-block" cols="12" md="6" />

        <v-col class="pa-2" cols="12" md="6">
          <color-picker v-model="colors.first" :label="$t('first_color')" />
        </v-col>

        <v-col class="pa-2" cols="12" md="6">
          <color-picker v-model="colors.second" :label="$t('second_color')" />
        </v-col>
      </v-row>

      <!-- حالت ساده -->
      <v-row v-else class="mx-auto" no-gutters>
        <v-col class="pa-2" cols="12" md="6">
          <color-picker v-model="colors.bodyColor" :label="$t('color')" />
        </v-col>
      </v-row>
    </div>
  </help-info-wrapper>
</template>

<script>
import { Bus } from "@/main";
import ColorPicker from "@/view/pages/qrland/components/colorPicker.vue";

export default {
  name: "colorPallete",

  components: { ColorPicker },

  props: {
    value: String,
  },

  data() {
    return {
      helpData: [],
      serviceName: "Qrland",
      componentName: "color-pallete",
      gradient: true,
      colors: {
        first: "",
        second: "",
        dir: "to right",
        bodyColor: "#000000", // برای حالت ساده
      },
    };
  },

  computed: {
    direction() {
      return [
        { text: this.$t("from_top"), value: "to top" },
        { text: this.$t("from_bottom"), value: "to bottom" },
        { text: this.$t("from_left_to_right"), value: "to right" },
        { text: this.$t("from_right_to_left"), value: "to left" },
        { text: this.$t("from_top_to_left"), value: "to top left" },
        { text: this.$t("from_top_to_right"), value: "to top right" },
        { text: this.$t("from_bottom_to_left"), value: "to bottom left" },
        { text: this.$t("from_bottom_to_right"), value: "to bottom right" },
      ];
    },
    computedValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },

  mounted() {
    const parsed = this.setColors(this.value);
    this.colors = {
      first: "",
      second: "",
      dir: "to right",
      bodyColor: "#000000",
    };
    if (parsed) {
      this.gradient = true;
      this.colors = { ...this.colors, ...parsed };
    } else {
      this.gradient = false;
      this.colors.bodyColor = this.value || "#000000";
    }
  },

  watch: {
    "$i18n.locale": {
      handler() {
        this.$forceUpdate();
      },
      immediate: true,
      deep: true,
    },
    gradient(val) {
      Bus.$emit("gradientType", val);
      this.updateOutputColor();
    },
    colors: {
      deep: true,
      handler() {
        this.updateOutputColor();
      },
    },
    value: {
      deep: true,
      immediate: true,
      handler(val) {
        if (val?.length == 0) {
          this.gradient = false;
          this.colors = {
            first: "",
            second: "",
            dir: "to right",
            bodyColor: "#000000", // برای حالت ساده
          };
        } else {
          this.setColors(val);
        }
        // this.setColors(val);
        this.$emit("color", val);
      },
    },
  },

  methods: {
    updateOutputColor() {
      if (this.gradient) {
        const { dir, first, second } = this.colors;
        this.computedValue = `linear-gradient(${dir}, ${first}, ${second})`;
      } else {
        this.computedValue = this.colors.bodyColor || "#000000";
      }
    },

    setColors(val) {
      if (!val || typeof val !== "string" || !val.includes("linear-gradient"))
        return null;

      const d = {
        first: "",
        second: "",
        dir: "",
      };

      const matchDir = val.match(/linear-gradient\(([^,]+),/);
      const matchColors = val.match(
        /linear-gradient\([^,]+,\s*(#[\dA-Fa-f]{6,8})\s*,\s*(#[\dA-Fa-f]{6,8})\)/,
      );

      if (matchDir) {
        d.dir = matchDir[1].trim();
      }
      if (matchColors) {
        d.first = matchColors[1];
        d.second = matchColors[2];
      }

      return d;
    },
  },
};
</script>

<style scoped>
.sp-wrapper {
  padding: 12px 0;
  border-bottom: 1px dashed rgb(126, 130, 153);
}
</style>
